module.exports = __webpack_public_path__ + "static/031-a700b03be7567659bb050ac24ddef61b.jpg";